import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'ecp-live-chat-dialog',
  templateUrl: './live-chat-dialog.component.html',
  styleUrls: ['./live-chat-dialog.component.scss'],
  standalone: false,
})
export class LiveChatDialogComponent {
  constructor(public dialogRef: MatDialogRef<LiveChatDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}
}
